import React from "react"
import { Route, Switch } from "react-router-dom"

// import AuthenticatedRoute from "../../components/AuthenticatedRoute"
import UnauthenticatedRoute from "../../components/UnauthenticatedRoute"
import FormContainer from "../../components/FormContainer"
import Layout from "../../components/PublicLayout"
import BetaView from "./Beta"
import InviteView from "./Invite"
import OnboardingView from "./Onboarding"

const base = "/signup"

export default function SignUp() {
  return (
    <Layout title="Sign Up">
      <FormContainer>
        <Switch>
          <UnauthenticatedRoute exact path={`${base}/beta/:code`}>
            <BetaView />
          </UnauthenticatedRoute>
          <UnauthenticatedRoute exact path={`${base}/start`}>
            <OnboardingView />
          </UnauthenticatedRoute>
          {/* <UnauthenticatedRoute exact path={`${base}/association`}>
            <AssociationView />
          </UnauthenticatedRoute> */}
          <Route exact path={`${base}/invite/:token`}>
            <InviteView />
          </Route>
          <UnauthenticatedRoute path={`${base}*`}>
            <BetaView />
          </UnauthenticatedRoute>
        </Switch>
      </FormContainer>
    </Layout>
  )
}
